<template>
  <div>
    <div v-for="item in arr" :key="item.id" class="">
      <label class="">
        <input
          type="radio"
          :disabled="disabled"
          v-model="model"
          class=""
          ref="input"
          :value="item.level"
        />
        {{ item.text }}</label
      >
    </div>
  </div>
</template>

<script>
import InputBase from "./InputBase";

export default {
  mixins: [InputBase],
  data() {
    return {
      id: null,
      model: null,
    };
  },
  mounted() {
    this.id = this._uid;
  },
  props: ["label", "arr", "disabled"],
  watch: {
    model(v) {
      this.$emit("input", v);
    },
    value: {
      handler(va, old) {
        if (va === this.value2) return;
        this.model = va;
      },
      immediate: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/public_app/elements/RadioSelect.vue